var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 26.25V56.25H60V60H0V56.25H3.75V26.25H11.25V52.5H18.75V26.25H26.25V52.5H33.75V26.25H41.25V52.5H48.75V26.25H56.25ZM31.875 0L60 18.75V22.5H0V18.75L28.125 0H31.875ZM30 15C31.0547 15 31.9336 14.6484 32.6367 13.9453C33.3789 13.2031 33.75 12.3047 33.75 11.25C33.75 10.1953 33.3789 9.31641 32.6367 8.61328C31.9336 7.87109 31.0547 7.5 30 7.5C28.9453 7.5 28.0469 7.87109 27.3047 8.61328C26.6016 9.31641 26.25 10.1953 26.25 11.25C26.25 12.3047 26.6016 13.2031 27.3047 13.9453C28.0469 14.6484 28.9453 15 30 15Z",
    fill: "#753485"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbIcon);
export default __webpack_public_path__ + "static/media/arbIcon.ae12124b9b211835f36dae19122600a8.svg";
export { ForwardRef as ReactComponent };